export const CACHE_IMAGE = "CACHE_IMAGE";
export const IMAGE_CACHED = "IMAGE_CACHED";
